globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { memo } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import { Title, Wrapper, PrimaryList, Paragraph } from '../../';
import { useJobShiftsList } from './job-shifts.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobShifts = /*#__PURE__*/memo(function (_ref) {
  var jobType = _ref.jobType,
      daysRequiredPerWeek = _ref.daysRequiredPerWeek,
      daysRequiredPerWeekNumber = _ref.daysRequiredPerWeekNumber,
      shifts = _ref.shifts,
      shiftNotes = _ref.shiftNotes,
      applicationEntryPointButtonAsChild = _ref.children;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var jobShiftList = useJobShiftsList({
    daysRequiredPerWeek: daysRequiredPerWeek,
    daysRequiredPerWeekNumber: daysRequiredPerWeekNumber,
    shifts: shifts
  });
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      icon: "ClockIcon",
      content: t('hours'),
      variant: "h4-large",
      fontWeight: "semibold",
      textColor: "black"
    }, "main-title"), jobType && /*#__PURE__*/_jsx(Title, {
      content: "".concat(t('commitment'), " ").concat(jobType.toLowerCase(), ":"),
      variant: "h6-large",
      fontWeight: "semibold",
      textColor: "black"
    }, "job-time-title"), /*#__PURE__*/_jsx(JobShiftMainContent, {
      itemList: jobShiftList,
      shiftNotes: shiftNotes
    }), !isDesktop && /*#__PURE__*/_jsx(_Fragment, {
      children: applicationEntryPointButtonAsChild
    })]
  });
});
export default JobShifts;

var JobShiftMainContent = function JobShiftMainContent(_ref2) {
  var itemList = _ref2.itemList,
      _ref2$shiftNotes = _ref2.shiftNotes,
      shiftNotes = _ref2$shiftNotes === void 0 ? '' : _ref2$shiftNotes;

  var _useResponsiveBreakPo2 = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo2.isDesktop;

  var shiftNoteEl = shiftNotes ? /*#__PURE__*/_jsxs(ParagraphWrapper, {
    children: [isDesktop && /*#__PURE__*/_jsx(InformationCircleIconStyled, {}), /*#__PURE__*/_jsx(Paragraph, {
      content: shiftNotes
    }, "launch-available-if-early")]
  }) : null;
  return /*#__PURE__*/_jsxs(JobShiftContentWrapper, {
    children: [/*#__PURE__*/_jsx(PrimaryList, {
      itemList: itemList,
      type: "default"
    }, "time-table-list"), shiftNoteEl]
  });
};

var JobShiftContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-shifts__JobShiftContentWrapper",
  componentId: "sc-s27q82-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "space-between"
  }
});

var ParagraphWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-shifts__ParagraphWrapper",
  componentId: "sc-s27q82-1"
})({
  "@media (min-width: 768px)": {
    "width": "40%"
  }
});

var InformationCircleIconStyled = /*#__PURE__*/_styled(InformationCircleIcon).withConfig({
  displayName: "job-shifts__InformationCircleIconStyled",
  componentId: "sc-s27q82-2"
})({
  "marginBottom": "0.5rem",
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});